import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import "./App.css";

// Patch ResizeObserver to prevent "loop completed with undelivered notifications" errors
// triggered by CKEditor when the browser is resized rapidly.
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (entries.length) {
          callback(entries, observer);
        }
      });
    });
  }
};

const root = document.getElementById('root');
const rootInstance = createRoot(root);
rootInstance.render(<App />);